import { Button, Space, Typography } from "antd"

const { Link } = Typography

const Upsell = () => {
  return <Space direction="vertical">
    <h3>Automate Your Business with Zapier</h3>

    <p>Stop manually doing those pesky 5 min tasks over and over again and automate your busy work with SynkedUP's Zapier integration.
      With this integration you can connect your favorite apps and business tools to SynkedUP, and create customers, consultations, get notified when jobs are updated, and more.</p>

    <Link href="https://synkedup.com/upgrade/" target="_blank"><Button type="primary" size="large">Upgrade to PRO Now</Button></Link>
  </Space>
}
export default Upsell
